<template>
  <div></div>
</template>

<script>
import { getToken } from "@/utils/auth";
import { setupLoginWap } from "@/utils/auth";

export default {
  created() {
    setupLoginWap(this);
  }
};
</script>
